import './index.less';


// WEBPACK FOOTER //
// ./src/view/new/index.js